import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useSelector } from 'hooks/store';
import React, { ReactElement } from 'react';
import { breadcrumbsSelector } from 'state/slices/breadcrumb';

import {
  SectionBreadcrumb,
  SectionPageHeader,
} from './components';
import {
  MainContainer,
  StickyContainer,
} from './style';

interface SectionBasePageProps {
  title?: string
  titleAppend?: ReactElement
  extra?: ReactElement
  children?: ReactElement
}

const SectionBasePage = ({
  title,
  titleAppend,
  extra,
  children,
}: SectionBasePageProps): JSX.Element => {
  const breadcrumbNavigator = useBreadcrumbNavigation();
  const breadcrumbs = useSelector(breadcrumbsSelector);
  const breadcrumbsCount = breadcrumbs.length;
  const lastBreadcrumb = breadcrumbsCount > 0 ? breadcrumbs[breadcrumbsCount - 1] : undefined;
  const sectionTitle = title || lastBreadcrumb?.label;
  const onBack = breadcrumbsCount > 1
    ? () => breadcrumbNavigator.toPrevious()
    : undefined;

  const titleElement = (
    <>
      {sectionTitle}
      {titleAppend}
    </>
  );

  return (
    <MainContainer>
      <StickyContainer offsetTop={10}>
        <SectionBreadcrumb />
        {/* <SectionPageHeader title={sectionTitle} extra={extra} onBack={onBack} /> */}
        <SectionPageHeader title={titleElement} extra={extra} onBack={onBack} />
      </StickyContainer>
      { children }
    </MainContainer>
  );
};

SectionBasePage.defaultProps = {
  title: undefined,
  extra: null,
  children: null,
};

export default SectionBasePage;
